module.exports = __webpack_public_path__ + "static/media/upgrade-city.651e661e.svg";